module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Superscript-bf4ac46ed35f0281539623b4cde5aab5.svg";